"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxSyncPreferences = void 0;
function serializeHxSyncPreferences(_arg) {
    var output = [];
    output.push(_arg.syncNonInlineAttachmentsEnabled);
    output.push(_arg.syncInlineAttachmentsEnabled);
    output.push(_arg.syncRichContentEnabled);
    output.push(_arg.flightSyncMoreMessagesPerFolderInMobileEnabled);
    output.push(_arg.coordinatedUnreadCountEnabled);
    output.push(_arg.sendActionsInBackgroundEnabled);
    output.push(_arg.backgroundSyncEnabled);
    output.push(_arg.suggestedReplyTypePreference);
    output.push(_arg.remoteSharedCalendarsEnabled);
    output.push(_arg.syncInferredLocationsEnabled);
    output.push(_arg.clientRequestsEncryptedNotifications);
    output.push(_arg.htmlAutoReplyEnabled);
    output.push(_arg.pinMailItemSortEnabled);
    output.push(_arg.reportingSslCertificateErrorsEnabled);
    output.push(_arg.use3SV2SubstrateSearchForMail);
    output.push(_arg.use3SV2SubstrateSearchForCalendar);
    output.push(_arg.interestedInFirstBody);
    output.push(_arg.syncAllContactFoldersForHxSAccounts);
    output.push(_arg.syncActivityFeedEnabled);
    output.push(_arg.calendarIconAssetTypePreference);
    return output;
}
exports.serializeHxSyncPreferences = serializeHxSyncPreferences;
